/** Parse CSV text (`,` or `;` delimiter). First row = headers. */
export function parseCsv(text: string): {
    headers: string[];
    rows: string[][];
} {
    const cleaned = text.replace(/^\uFEFF/, "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    const lines = cleaned.split("\n").filter((line) => line.trim().length > 0);
    if (lines.length === 0) {
        return { headers: [], rows: [] };
    }

    const delimiter = detectDelimiter(lines[0]);
    const headers = splitCsvLine(lines[0], delimiter).map((h) => h.trim());
    const rows = lines.slice(1).map((line) => splitCsvLine(line, delimiter));

    return { headers, rows };
}

function detectDelimiter(headerLine: string): "," | ";" {
    const commas = (headerLine.match(/,/g) || []).length;
    const semis = (headerLine.match(/;/g) || []).length;
    return semis > commas ? ";" : ",";
}

function splitCsvLine(line: string, delimiter: "," | ";"): string[] {
    const cells: string[] = [];
    let current = "";
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
        const char = line[i];
        if (char === '"') {
            if (inQuotes && line[i + 1] === '"') {
                current += '"';
                i++;
            } else {
                inQuotes = !inQuotes;
            }
            continue;
        }
        if (char === delimiter && !inQuotes) {
            cells.push(current);
            current = "";
            continue;
        }
        current += char;
    }
    cells.push(current);
    return cells.map((c) => c.trim());
}

export function extractEmailsFromCsvColumn(
    headers: string[],
    rows: string[][],
    columnName: string
): string[] {
    const index = headers.findIndex((h) => h === columnName);
    if (index < 0) return [];

    const unique = new Set<string>();
    for (const row of rows) {
        const value = (row[index] ?? "").trim();
        if (!value || !value.includes("@")) continue;
        unique.add(value);
    }
    return Array.from(unique);
}

export function guessEmailColumn(headers: string[]): string {
    const lower = headers.map((h) => h.toLowerCase());
    const exact = lower.findIndex(
        (h) => h === "email" || h === "e-mail" || h === "mail"
    );
    if (exact >= 0) return headers[exact];
    const partial = lower.findIndex((h) => h.includes("email") || h.includes("mail"));
    if (partial >= 0) return headers[partial];
    return headers[0] ?? "";
}
